import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const confirmBalanceTopUp = (payload: { amount: number, fees: number }) => {
    return axiosPrivate.post('/bills/api/v1/confirm-top-up/', payload, { allow403: true } as CustomAxiosRequestConfig);
}

